// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"1c206026","192":"cf9b2fb3","194":"baa408ae","249":"d29959c7","530":"688f9b9c","734":"c122c529"}[chunkId] + ".chunk.js";
};